import { Box, Grid2, Icon, IconButton, LinearProgress, List, ListItem, ListItemText, Typography } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IFilteringViewModel, ITableData } from "../../../_common/interface/table";
import { StandardButton } from "../../../_components/button/primary.button";
import { CommonTable } from "../../../_components/table/common.table";
import { toastr } from "../../../_components/toastr/toastr";
import { formFieldKeyLookupService } from "../../../_services/formFieldKeyLookup.service";


export function FormFieldKeyLookupList(params: {
}) {
    let navigate = useNavigate();
    const { formFieldKeyId } = useParams<{ formFieldKeyId: string }>();
    const _formFieldKeyId = +(formFieldKeyId || 0);

    const [data, setData] = useState<ITableData<any>>({ items: [], count: 0 });
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    const [filter, setFilter] = useState<IFilteringViewModel>({});

    useEffect(() => {
        if (_formFieldKeyId) fetchData();
        else setData({ items: [], count: 0 });
    }, [_formFieldKeyId]);

    function fetchData() {
        setLoading(true);
        return formFieldKeyLookupService
            .getAll(_formFieldKeyId)
            .then(
                (json) => {
                    console.log(json);
                    setData(json)
                }
            )
            .finally(() => setLoading(false));
    }

    function disable(id?: number) {
        if (!id) return;

        setSaving(true);
        return formFieldKeyLookupService
            .disable(id ?? 0)
            .then(
                () => {
                    toastr.success("Disabled successfully");
                    fetchData();
                }
            )
            .finally(() => setSaving(false));
    }

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                id: 'actions',
                header: 'Actions',
                size: 80,
                enableSorting: false,
                enableColumnFilter: false,
                Cell: ({ row }) => (
                    <IconButton
                        color="primary"
                        onClick={() => { navigate("EditFormFieldKeyLookup/" + row.original.id) }}>
                        <Icon>edit</Icon>
                    </IconButton>
                ),
            },
            {
                accessorKey: 'id',
                header: '#',
            },
            {
                accessorKey: 'lookupValue',
                header: 'Value',
            },
            {
                accessorKey: 'label',
                header: 'Label',
            },
            {
                accessorKey: 'hasSelectCondition',
                header: 'Has Select',
                render: (rowData: any) => <>{rowData.hasSelectCondition?.toString()}</>
            },
            {
                accessorKey: 'formFieldActionName',
                header: 'Action',
            }
        ],
        [],
    );

    return (

        <>
            <Grid2 container>
                <Grid2 size={{ xs: 12 }}>

                    {loading && <LinearProgress />}

                    {((!data || !data.items || !!!data.items.length) && !loading) &&
                        <Box display="flex" alignItems="center" justifyContent="center" sx={{ p: 1 }}>
                            <Typography color="text.secondary" fontStyle="italic">
                                No Associated Lookup values
                            </Typography>
                        </Box>
                    }

                    <List dense={true}>
                        {(data && data.items && !!data.items.length) && data.items.map(item =>
                            <ListItem sx={{ paddingLeft: "4px" }}
                                key={item.id}
                                disableGutters

                                secondaryAction={<>
                                    <IconButton
                                        // disabled={params.formStatus !== FormStatusEnum.New && params.formStatus !== FormStatusEnum.InProcess} 
                                        edge="end" aria-label="edit" onClick={() => { navigate("EditFormFieldKeyLookup/" + item.id) }}>
                                        <Icon>edit</Icon>
                                    </IconButton>

                                    <IconButton
                                        // disabled={params.formStatus !== FormStatusEnum.New && params.formStatus !== FormStatusEnum.InProcess} 
                                        edge="end" aria-label="delete" onClick={() => disable(item.id)}>
                                        <Icon>delete</Icon>
                                    </IconButton>
                                </>}>
                                <ListItemText
                                    primary={item.lookupValue}
                                />
                            </ListItem>

                        )}
                    </List>

                </Grid2>
                <Grid2 size={{ xs: 12 }}>
                    <StandardButton
                        type="button"
                        icon="add"
                        disabled={loading}
                        onClick={() => { navigate(`CreateFormFieldKeyLookup/`) }}>
                        Add New
                    </StandardButton>
                </Grid2>
            </Grid2 >
        </>

    );
}